(ns app.front.view.admin.gis.subs
  (:require [app.front.entities :as entities]
            [app.front.view.admin.common :as admin-common]
            [app.front.view.admin.domain-groups.municipality-groups :as municipality-groups]
            [app.front.view.admin.domain-groups.upper-tier-groups :as upper-tier-groups]
            [app.front.view.admin.superdomain :as admin-superdomain]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::init
  (fn [_ _]
    {:fx [[:dispatch [::upper-tier-groups/fetch-upper-tier-groups]]
          [:dispatch [::municipality-groups/fetch-municipalities]]
          [:dispatch [::admin-superdomain/fetch-superdomains]]
          [:dispatch [::fetch-gis-configs]]
          [:dispatch [::fetch-custom-configs]]]}))


(rf/reg-event-fx ::fetch-gis-configs
  (fn [_ _]
    {:comm/command {:command    :admin/gis-configs
                    :method     :get
                    :on-success [::entities/merge-entity-db]}}))


(rf/reg-event-db
  ::set-custom-configs
  (fn [db [_ _ data]]
    (assoc db ::custom-configs data)))


(rf/reg-event-fx ::fetch-custom-configs
  (fn [_ _]
    {:comm/command {:command    :admin/custom-configs
                    :method     :get
                    :on-success [::set-custom-configs]}}))


(rf/reg-sub ::custom-configs :-> ::custom-configs)


(rf/reg-sub ::domain-group-custom-configs
  :<- [::admin-common/domain-groups-of-authorities]
  :<- [::custom-configs]
  (fn [[groups configs]]
    (->> groups
         (map (fn [{:group/keys [id name] :as group}]
                (when-let [config (p/find-first configs {:group-id id})]
                  (assoc config :group-name name
                         :group-db-id (:db/id group)))))
         (remove nil?))))


(rf/reg-sub ::groupless-custom-configs
  :<- [::admin-common/domain-groups-of-authorities]
  :<- [::custom-configs]
  (fn [[groups configs]]
    (let [group-ids (->> groups (map :group/id) set)]
      (->> configs
           (remove #(contains? group-ids (:group-id %)))))))


(rf/reg-sub ::groups-with-custom-configs
  :<- [::domain-group-custom-configs]
  (fn [configs [_ group-ids]]
    (let [config-group-ids (->> configs
                                (map :group-db-id)
                                set)]
      (->> group-ids
           (filter #(->> % (contains? config-group-ids)))
           seq))))
